const Tag = {
  variants: {
    subtle: {
      container: {
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '15px',
        padding: '4px 12px',
        svg: {
          color: 'primary.700',
        },
      },
      label: {
        fontWeight: 400,
        textTransform: 'capitalize',
      },
    },
  },
  sizes: {
    lg: {
      container: {
        svg: {
          height: '16px',
          width: '16px',
        },
      },
    },
  },
  defaultProps: {
    variant: 'subtle',
    colorScheme: 'primary',
    size: 'lg',
  },
};

export default Tag;
